import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Sankey from './index';
import SankeyControls from './SankeyControls';
import { useSankey } from '../../hooks/useSankey';

const SankeyContainer = ({ 
  type, 
  id, 
  title, 
  showControls = true,
  initialParams = {},
  controlsConfig = {}
}) => {
  const [params, setParams] = useState(initialParams);
  const { transformedData, loading, error, refetch, hasData } = useSankey(type, id, params);

  const handleParamsChange = (newParams) => {
    setParams(newParams);
  };

  const handleRefresh = () => {
    refetch();
  };

  return (
    <div className="sankey-container">
      {showControls && (
        <SankeyControls
          onParamsChange={handleParamsChange}
          initialParams={params}
          {...controlsConfig}
        />
      )}
      
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <div>
          {transformedData?.metadata && (
            <div style={{ fontSize: '0.9rem', color: '#6c757d' }}>
              {transformedData.metadata.proyectoNombre && (
                <span>Proyecto: {transformedData.metadata.proyectoNombre} | </span>
              )}
              {transformedData.metadata.elementoNombre && (
                <span>Elemento: {transformedData.metadata.elementoNombre} | </span>
              )}
              {transformedData.metadata.tarjetaNombre && (
                <span>Tarjeta: {transformedData.metadata.tarjetaNombre} | </span>
              )}
              {transformedData.metadata.sensoresCount && (
                <span>Sensores: {transformedData.metadata.sensoresCount}</span>
              )}
            </div>
          )}
        </div>
        
        <button
          onClick={handleRefresh}
          disabled={loading}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: loading ? '#6c757d' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '0.9rem',
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.2s'
          }}
        >
          {loading ? 'Actualizando...' : 'Actualizar'}
        </button>
      </div>

      <Sankey
        data={transformedData}
        title={title}
        isNewFormat={true}
        loading={loading}
        error={error}
      />

      {!loading && !error && !hasData && (
        <div style={{ 
          textAlign: 'center', 
          padding: '2rem', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '8px',
          border: '1px solid #e9ecef',
          marginTop: '1rem'
        }}>
          <p style={{ color: '#6c757d', margin: 0 }}>
            No hay datos disponibles para mostrar en la gráfica Sankey.
          </p>
          <p style={{ color: '#6c757d', margin: '0.5rem 0 0 0', fontSize: '0.9rem' }}>
            Intenta ajustar los filtros o verifica que existan sensores con datos en el período seleccionado.
          </p>
        </div>
      )}
    </div>
  );
};

SankeyContainer.propTypes = {
  type: PropTypes.oneOf(['proyecto', 'elemento', 'tarjeta']).isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  showControls: PropTypes.bool,
  initialParams: PropTypes.shape({
    limite: PropTypes.number,
    unidades: PropTypes.arrayOf(PropTypes.string),
    incluirInactivos: PropTypes.bool
  }),
  controlsConfig: PropTypes.shape({
    showUnidadesFilter: PropTypes.bool,
    showLimiteControl: PropTypes.bool,
    showInactivosToggle: PropTypes.bool
  })
};

export default SankeyContainer;